/**
 * True when the UA is WebKit Safari on iPhone/iPad/iPod (not Chromium-based
 * browsers that also include "Safari" in the string).
 */
export function isIOSSafari(userAgent) {
  const ua =
    userAgent ??
    (typeof navigator !== "undefined" ? navigator.userAgent : "");
  return (
    /safari/i.test(ua) &&
    !/chrome/i.test(ua) &&
    /iPhone|iPad|iPod/i.test(ua)
  );
}

/**
 * True on any mobile browser (iOS Safari, Chrome for Android, Samsung Internet, etc.).
 * Used for: (1) tighter image decode caps, (2) sequential ONNX sessions (splash does not warm-load
 * all three WASM sessions; upload loads Fundus → DR/DME → Eyes one at a time with releases).
 */
export function isMobileBrowser(userAgent) {
  const ua =
    userAgent ??
    (typeof navigator !== "undefined" ? navigator.userAgent : "");
  return /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
}
